module.exports = __webpack_public_path__ + "static/media/AyCsite_Logo.d8dcbe6f.png";